import { render, staticRenderFns } from "./CheckoutTermsAndConditions.vue?vue&type=template&id=5ad34832&scoped=true&"
import script from "./CheckoutTermsAndConditions.vue?vue&type=script&lang=js&"
export * from "./CheckoutTermsAndConditions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad34832",
  null
  
)

export default component.exports